module.exports = __webpack_public_path__ + "img/2.151d4534.png";